import * as React from "react";

const CustomCloseIcon: React.FC = () => {
    return (
        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M15.625 13.9315C16.075 14.4299 16.075 15.1776 15.625 15.6262C15.125 16.1246 14.375 16.1246 13.925 15.6262L8.025 9.6947L2.075 15.6262C1.575 16.1246 0.825 16.1246 0.375 15.6262C-0.125 15.1776 -0.125 14.4299 0.375 13.9315L6.325 8L0.375 2.06854C-0.125 1.57009 -0.125 0.82243 0.375 0.373832C0.825 -0.124611 1.575 -0.124611 2.025 0.373832L8.025 6.35514L13.975 0.423676C14.425 -0.0747664 15.175 -0.0747664 15.625 0.423676C16.125 0.872274 16.125 1.61994 15.625 2.11838L9.675 8L15.625 13.9315Z"
                fill="#474747"
            />
        </svg>
    );
};

export default React.memo(CustomCloseIcon);
